import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { IFloatingFilterParams } from 'ag-grid-community';
import { AgFloatingFilterComponent } from 'ag-grid-angular';
import { IntegrationService } from '../../../shared/services/integration.service';
import { FormsModule } from '@angular/forms';
import { NgClass } from '@angular/common';

@Component({
    selector: 'text-filter-component',
    template: `<input
        #eInput
        class="ag-text-field-input"
        type="text"
        [(ngModel)]="currentValue"
        (click)="openMenu()"
        [ngClass]="currentValue ? 'input-background-active' : ''" />
        @if (!currentValue) {
          <span class="sdps-dropdown__icon sch-chevron-small-down"></span>
        }
        @if (currentValue) {
          <span class="sdps-text-secondary delete-icon-padding" (click)="clearTextField($event)"
            ><img class="deleteIcon" [src]="deleteIcon"
          /></span>
        }`,
    styleUrls: ['./text-floating-filter.component.scss'],
    standalone: true,
    imports: [FormsModule, NgClass]
})
export class TextFloatingFilterComponent implements OnInit, AgFloatingFilterComponent {
  @ViewChild('eInput', { read: ElementRef, static: true }) eInput: ElementRef;
  params: IFloatingFilterParams;
  currentValue: Number | null | string = null;
  public deleteIcon: string;
  constructor(private integrationService: IntegrationService) {}

  ngOnInit(): void {
    const assetUrl = this.integrationService.getApplicationPath();
    this.deleteIcon = assetUrl + 'assets/images/Delete.svg';
  }

  agInit(params: IFloatingFilterParams): void {
    this.params = params;
  }

  openMenu(): void {
    this.params.showParentFilter();
  }

  onParentModelChanged(parentModel: any): void {
    // When the filter is empty we will receive a null value here
    if (!parentModel) {
      this.currentValue = null;
    } else {
      this.currentValue = parentModel.filter;
    }
  }
  clearTextField(event): void {
    event.preventDefault();
    this.currentValue = null;
    this.onParentModelChanged(this.clearTextField);
  }
}
